import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{--spectrum-thumbnail-border-radius:var(--system-thumbnail-border-radius)}
`;
export default styles;